import type { AdsActivityStatusVerdict } from "@/lib/adsAssistantClientEngagement";

export type AdsActivityCtaResolvedKind =
  | "none"
  | "scroll_manual"
  | "scroll_posts"
  | "open_library"
  | "open_ingestion";

export type AdsActivityCtaResolved = {
  kind: AdsActivityCtaResolvedKind;
  /** Button label after role / context adjustments. */
  label: string;
};

const LIBRARY_MARKER = "mode=library";

function isLibraryRoute(route: string): boolean {
  return route.includes(LIBRARY_MARKER);
}

/**
 * Maps server verdict CTA to an in-app action. Sales users never get "Open library"
 * (they cannot access Library); gold-at-cap / grey spam states fall back to
 * "View today's posts" + scroll to the indexed-posts anchor.
 */
export function resolveAdsActivityCta(args: {
  verdict: AdsActivityStatusVerdict | null | undefined;
  canOpenLibrary: boolean;
  hasManualForm: boolean;
}): AdsActivityCtaResolved {
  const { verdict, canOpenLibrary, hasManualForm } = args;
  if (!verdict) return { kind: "none", label: "" };

  if (verdict.label === "Coaching off") {
    return { kind: "none", label: "" };
  }

  const baseLabel = verdict.next_action_label.trim();
  const route = verdict.next_action_route;

  if (isLibraryRoute(route)) {
    if (canOpenLibrary) {
      return { kind: "open_library", label: baseLabel };
    }
    return { kind: "scroll_posts", label: "View today's posts" };
  }

  if (hasManualForm) {
    return { kind: "scroll_manual", label: baseLabel };
  }
  return { kind: "open_ingestion", label: baseLabel };
}
